import { Component, inject, ChangeDetectionStrategy } from "@angular/core";
import {
	MAT_DIALOG_DATA,
	MatDialogRef,
	MatDialogContent,
	MatDialogActions,
	MatDialogClose,
} from "@angular/material/dialog";
import { FormulaChoice } from "../../../entities/formula/formula-choice";
import { MatButton } from "@angular/material/button";

import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { MatRadioGroup, MatRadioButton } from "@angular/material/radio";
import { TranslatePipe } from "@tolgee/ngx";

@Component({
	selector: "app-formule-variable-multichoice",
	templateUrl: "./formule-variable-multichoice.component.html",
	styleUrls: ["./formule-variable-multichoice.component.scss"],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [
		MatDialogContent,
		MatRadioGroup,
		ReactiveFormsModule,
		FormsModule,
		MatRadioButton,
		MatDialogActions,
		MatButton,
		MatDialogClose,
		TranslatePipe,
	],
})
export class FormuleVariableMultichoiceComponent {
	choices = inject(MAT_DIALOG_DATA);
	private dialogRef = inject<MatDialogRef<FormuleVariableMultichoiceComponent>>(MatDialogRef);

	result: FormulaChoice;

	returnValue() {
		this.dialogRef.close(this.result);
	}
}
